import Fetch from 'utils/fetch';
import { settings } from 'settings';

export interface PerformanceScanByTimePerStore {
  timePart: string;
  senderEmail: string;
  nrOfFirstScans?: number;
  totalNrOfScans?: number;
  nrOfCompletedScans?: number;
  firstScan?: string;
}

export async function fetchScanPerformanceByTimePerStore(
  startDate: string,
  endDate: string
): Promise<PerformanceScanByTimePerStore[]> {
  try {
    const response: Response = await Fetch.put({
      url: `${settings.newApiUrl}/scan/scanPerformanceByTimePerStore?start=${startDate}&end=${endDate}`,
    });

    if (response.ok) {
      const performanceScanList: PerformanceScanByTimePerStore[] =
        await response.json();
      return performanceScanList;
    }
  } catch (error) {
    return [];
  }
}
